import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import { initSentry } from "@/lib/sentry";
import { FeatureFlagProvider } from "@/lib/feature-flags/provider";
import { seedDevAuth } from "@/lib/devAuth"; // prototype-only auth bypass + in-browser mock
import { DevBar } from "@/prototypes/contract-royalty-rates/DevBar"; // prototype-only variant switches

initSentry();
seedDevAuth(); // prototype-only auth bypass + in-browser mock

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <FeatureFlagProvider>
      <App />
      <DevBar />
    </FeatureFlagProvider>
  </StrictMode>
);
